// What the user has already seen or dismissed, remembered in localStorage: pop-ups and banners shown
// once, and the sidebar dots of pages they have opened. Each key is followed by the user's id (and
// for some an organisation or pharmacy id), so on a shared browser one person's choice doesn't hide
// anything from the next. Logging out clears the rest of localStorage but keeps these, so nothing
// comes back on every login. A new pop-up shown once adds its key here.

export const NEW_PLAN_FEATURES_SEEN_KEY = 'new_plan_features_seen';
export const WEB_BUILDER_PROMO_DISMISSED_KEY = 'web_builder_promo_dismissed';
export const COMMAND_CENTRE_WELCOME_DISMISSED_KEY = 'command-centre-welcome-dismissed';
export const INVITE_PATIENTS_SUGGESTION_DISMISSED_KEY = 'command-centre-invite-patients-dismissed';
export const CATALOGUE_WHATS_NEW_DISMISSED_KEY = 'hide_catalogue_whats_new_modal';
export const UBER_EATS_INTRO_DISMISSED_KEY = 'uber_eats_intro_dismissed';
export const SUPER_LINKS_ONBOARDING_DISMISSED_KEY = 'super_links_onboarding_dismissed';
export const SMS_CAMPAIGNS_ONBOARDING_ACKNOWLEDGED_KEY = 'sms-campaigns-onboarding-acknowledged';
export const SMS_CAMPAIGNS_BANNER_DISMISSED_KEY = 'smsCampaignsBannerAdDismissed';
export const NEWLY_INCLUDED_PAGES_SEEN_KEY = 'newly-included-pages-seen';
export const WHATS_NEW_LAST_SEEN_KEY = 'whats-new-last-seen';

const SEEN_KEYS = [
  NEW_PLAN_FEATURES_SEEN_KEY,
  WEB_BUILDER_PROMO_DISMISSED_KEY,
  COMMAND_CENTRE_WELCOME_DISMISSED_KEY,
  INVITE_PATIENTS_SUGGESTION_DISMISSED_KEY,
  CATALOGUE_WHATS_NEW_DISMISSED_KEY,
  UBER_EATS_INTRO_DISMISSED_KEY,
  SUPER_LINKS_ONBOARDING_DISMISSED_KEY,
  SMS_CAMPAIGNS_ONBOARDING_ACKNOWLEDGED_KEY,
  SMS_CAMPAIGNS_BANNER_DISMISSED_KEY,
  NEWLY_INCLUDED_PAGES_SEEN_KEY,
  WHATS_NEW_LAST_SEEN_KEY,
];

function isSeenKey(key: string): boolean {
  return SEEN_KEYS.some(
    (seenKey) => key.startsWith(`${seenKey}-`) || key.startsWith(`${seenKey}:`)
  );
}

export function clearLocalStorageExceptSeen(): void {
  Object.keys(localStorage)
    .filter((key) => !isSeenKey(key))
    .forEach((key) => localStorage.removeItem(key));
}
